module.exports = "/assets/data/ea2b858af575b4053955ce8fcefff16b-CF46.data.json";